import React from "react";
import slack from "src/assets/icons/slack";
import Icon from "src/components/icon";
import request from "src/utils/request";
import { Box, CircularProgress, Grid } from "@mui/material";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Flex from "../../components/flex";
import useQueryParams from "../../hooks/use-query-params";
import { getSlackRedirectUrl } from "./utils";

const H1 = styled.h1`
    font-size: 22px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const SlackOauth = () => {
    const query = useQueryParams();
    const navigate = useNavigate();

    const integrateMethod = async () => {
        const code = query.get("code");
        const error = query.get("error");

        if (!code && !error) navigate("/integrations");

        if (error) {
            if (error === "access_denied") {
                return navigate("/integrations/denied/slack");
            }
            return navigate("/integrations/failure/slack");
        }

        try {
            await request(`/api/slack/oauth?code=${code}&redirect_url=${getSlackRedirectUrl()}`);
            localStorage.setItem("cidt", new Date().valueOf().toString());
            return navigate("/integrations/success/slack");
        } catch (err) {
            return navigate("/integrations/failure/slack");
        }
    };

    React.useEffect(() => {
        integrateMethod();
    }, [query]);

    return (
        <Box mt={10}>
            <Grid
                container
                spacing={3}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Grid item>
                    <Icon svg={slack} width="250px" height="auto" />
                </Grid>
                <Grid item style={{ textAlign: "center" }}>
                    <H1>Plugging in Slack</H1>
                    <Span>You will be redirected momentarily</Span>
                </Grid>
                <Grid item style={{ marginTop: "40px" }}>
                    <Flex justifyContent="center">
                        <CircularProgress size={50} />
                    </Flex>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SlackOauth;
